import { apiRequest } from "./client";

export const adminApi = {
  overview() {
    return apiRequest("/admin/overview");
  },
};
